import { propertyGroupQueryKeys as e } from "./propertyGroupQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyGroupsApi as n } from "@maat/api-main";
//#region src/propertyGroups/usePropertyGroupQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getGroup(r),
	enabled: !!r
});
//#endregion
export { r as usePropertyGroupQuery };
